/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeHeading3, BaSeShapeButton } from '@base/react';
import React from 'react';
import Slider from 'react-slick/lib/slider';
import { depoimentsData } from '../../data/depoiments';
import { useDisplay } from '../../hook/useDisplay';
import Depoiment from './depoiment';

import {
  Container,
  ContainerText,
  Content,
  ContentDepoiments
} from './style';

function Depoiments() {


  const { isLargeDisplay, breakpointController } = useDisplay();

  const [currentIndex, setCurrentIndex] = React.useState(0);

  const showNextDepoiment = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % depoimentsData.length);
  };

  const showPreviousDepoiment = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? depoimentsData.length - 1 : prevIndex - 1,
    );
  };



  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <></>,
    prevArrow: <></>,

    customPaging: (i) => (
      <div
        style={{
          height: '5px',
          borderRadius: 100,
          backgroundColor: '#8B99A7',
        }}
      >
        ‎
      </div>
    ),

  };

  const isMobile = !breakpointController.inDesktop &&
    !breakpointController.inDesktopLarge && !breakpointController.inTablet


  return (
    <Container id="6">
      <Content>
        <ContainerText>
          <BaSeHeading3>
            Quem fez <strong>recomenda</strong>
          </BaSeHeading3>
        </ContainerText>

        {
          isMobile ?
            (
              <Slider {...settings}>
                {depoimentsData.map((item) => (
                  <div style={{ width: '100%' }}>
                    <Depoiment
                      city={item.city}
                      id={item.id}
                      lengthList={depoimentsData.length}
                      desc={item.desc}
                      name={item.name}
                    />


                  </div>
                ))}
              </Slider>

            )

            : (
              <ContentDepoiments>
                {isLargeDisplay() ? (
                  currentIndex > 0 ? (
                    <BaSeShapeButton
                      buttonType="button"
                      color="#FF9797"
                      nameIcon="system/arrow-left-s-line"
                      onClick={showPreviousDepoiment}
                      shape="circle"
                      size="medium"
                      sizeIcon="medium"
                      type="primary"
                    />
                  ) : (
                    <div style={{ width: 40 }}>‎ </div>
                  )
                ) : (
                  <></>
                )}

                <Depoiment
                  city={depoimentsData[currentIndex].city}
                  id={depoimentsData[currentIndex].id}
                  lengthList={depoimentsData.length}
                  desc={depoimentsData[currentIndex].desc}
                  name={depoimentsData[currentIndex].name}
                />


                {isLargeDisplay() ? (
                  currentIndex === depoimentsData.length - 1 ? (
                    <div style={{ width: 40 }}>‎ </div>
                  ) : (
                    <BaSeShapeButton
                      buttonType="button"
                      color="#FF9797"
                      nameIcon="system/arrow-right-s-line"
                      onClick={showNextDepoiment}
                      shape="circle"
                      size="medium"
                      sizeIcon="medium"
                      type="primary"
                    />
                  )
                ) : (
                  <></>
                )}
              </ContentDepoiments>
            )
        }


      </Content>

    </Container>
  );
}

export default Depoiments;
